
    import '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/plugins/snapline.zh.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-tutorial-plugins-snapline-demo-plugin-snapline"],
  getter: () => import(/* webpackChunkName: "meta__docs__zh" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/plugins/snapline.zh.md?type=demo')
};